<template>
  <div></div>
</template>

<script>
  /*
   * Shim for the retired /login, /register and /reset-password pages. Auth now lives
   * in a popup, but these URLs are still in reset-password emails and bookmarks, so
   * they land on the merchant home with the matching popup view already open.
   */
  import { mapGetters } from 'vuex';
  import { prepareAuthModal, AUTH_QUERY_KEY, AUTH_VIEW } from '@/utils/authModal.js';

  const LEGACY_PARAM_SEPARATOR = '.';

  export default {
    name: 'AuthRedirect',
    computed: {
      ...mapGetters(['getMerchant', 'isLoggedIn'])
    },
    created() {
      const merchantCode = this.getMerchant.code || this.$route.params.merchant_code;
      const homePath = window.IS_MERCHANT_CODE_HIDE ? '/' : `/${merchantCode}`;

      if (this.isLoggedIn) {
        this.$router.replace({ path: `${homePath}/account`.replace('//', '/') });
        return;
      }

      const view = this.$route.meta.auth_view || AUTH_VIEW.LOGIN;
      const opened = prepareAuthModal({ view: view, redirect: this.legacyRedirect(merchantCode) });

      const query = {};
      if (opened) query[AUTH_QUERY_KEY] = view;

      this.$router.replace({ path: homePath, query: query });
    },
    methods: {
      /* old links carried the target as ?next_page=<route name>&params=<key>.<value> */
      legacyRedirect(merchantCode) {
        const nextPage = this.$route.query.next_page;
        if (!nextPage) return null;

        const params = { merchant_code: merchantCode };
        const rawParam = this.$route.query.params;
        if (rawParam && rawParam.indexOf(LEGACY_PARAM_SEPARATOR) !== -1) {
          const separatorIndex = rawParam.indexOf(LEGACY_PARAM_SEPARATOR);
          params[rawParam.slice(0, separatorIndex)] = rawParam.slice(separatorIndex + 1);
        }

        return { name: nextPage, params: params };
      }
    }
  }
</script>



// WEBPACK FOOTER //
// src/pages/general/AuthRedirect.vue